import React, { useEffect, useRef, useState } from "react";
import "./MasterScreen.css";

export default function MasterScreen() {

const [rows, setRows] = useState([]);
const [search, setSearch] = useState("");
const [selectedId, setSelectedId] = useState(null);

const [mobileTab,setMobileTab] = useState("list");
const isMobile = window.innerWidth <= 768;

const firstInputRef = useRef(null);

const [showUnitPopup,setShowUnitPopup] = useState(false);
const [unitSearch,setUnitSearch] = useState("");

const [errors,setErrors] = useState({
itemName:"",
hsnCode:""
});

const [adder,setAdder] = useState({
itemName:"",
rate:"",
hsnCode:"",
taxPercent:"",
unitValue:"",
unitType:""
});

const unitOptions = [
"kg","gram","litre","ml","meter","cm","mm",
"piece","box","bag","roll","packet","dozen",
"bundle","set","pair","sheet","carton"
];

const filteredUnits = unitOptions.filter(u =>
u.toLowerCase().includes(unitSearch.toLowerCase())
);

useEffect(()=>{
loadItems();
},[]);

async function loadItems(){
try{
const res = await fetch("/api/items");
const data = await res.json();
setRows(data);
}catch(err){
console.error(err);
}
}

async function saveItem(){

if(!adder.itemName.trim()){
alert("Item Name required");
return;
}

const duplicate = rows.find(r =>
r.id !== selectedId &&
r.itemName?.trim().toUpperCase() === adder.itemName.trim().toUpperCase() &&
r.hsnCode?.trim().toUpperCase() === adder.hsnCode.trim().toUpperCase()
);

if(duplicate){
alert("Item with same Name + HSN already exists!");
return;
}

const payload={
itemName:adder.itemName,
rate:adder.rate,
hsnCode:adder.hsnCode,
taxPercent:adder.taxPercent,
unitValue:adder.unitValue,
unitType:adder.unitType
};

try{

if(selectedId){

await fetch(`/api/items/${selectedId}`,{
method:"PUT",
headers:{ "Content-Type":"application/json"},
body:JSON.stringify(payload)
});

}else{

await fetch("/api/items",{
method:"POST",
headers:{ "Content-Type":"application/json"},
body:JSON.stringify(payload)
});

}

await loadItems();
resetForm();

}catch(err){
console.error(err);
}

}

function resetForm(){

setAdder({
itemName:"",
rate:"",
hsnCode:"",
taxPercent:"",
unitValue:"",
unitType:""
});

setSelectedId(null);

setTimeout(()=>firstInputRef.current?.focus(),50);

}

function handleRowDoubleClick(row){

setAdder({
itemName:row.itemName || "",
rate:row.rate || "",
hsnCode:row.hsnCode || "",
taxPercent:row.taxPercent || "",
unitValue:row.unitValue || "",
unitType:row.unitType || ""
});

setSelectedId(row.id);

if(isMobile){
setMobileTab("entry");
}

setTimeout(()=>firstInputRef.current?.focus(),50);

}

const filtered = rows.filter(r=>{
if(!search.trim()) return true;

const q = search.toLowerCase();

return(
r.itemName?.toLowerCase().includes(q) ||
r.hsnCode?.toLowerCase().includes(q) ||
String(r.rate).includes(q) ||
String(r.taxPercent).includes(q)
);

});

function validateDuplicate(name,hsn){

const duplicate = rows.find(r =>
r.id !== selectedId &&
r.itemName?.trim().toUpperCase() === name.trim().toUpperCase() &&
r.hsnCode?.trim().toUpperCase() === hsn.trim().toUpperCase()
);

if(duplicate){

setErrors(prev=>({
...prev,
itemName:"Item with same Name + HSN already exists"
}));

return true;

}else{

setErrors(prev=>({
...prev,
itemName:""
}));

return false;

}

}

return(

<div className="ms-root">

<div className="ms-header">MASTER</div>

<div className="ms-body">

<div className="ms-left">

<div className="ms-form-card">

<div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>

<div style={{fontWeight:700}}>LIST</div>

<div style={{display:"flex",gap:8}}>

<input
className="ms-search-input"
placeholder="Search list"
value={search}
onChange={(e)=>setSearch(e.target.value)}
/>

<button className="ms-btn" onClick={()=>setSearch("")}>
Clear
</button>

</div>

</div>
<div className="ms-grid-header">
  <div className="ms-grid-col-head">CODE</div>
  <div className="ms-grid-col-head">ITEM NAME</div>
  <div className="ms-grid-col-head">UNIT VALUE</div>
  <div className="ms-grid-col-head">UNIT TYPE</div>
  <div className="ms-grid-col-head">RATE</div>
  <div className="ms-grid-col-head">HSN CODE</div>
  <div className="ms-grid-col-head">% OF TAX</div>
</div>
{/* LIST SECTION */}

{(!isMobile || mobileTab==="list") && (

<div className="ms-grid-body">

{isMobile ? (

<div className="ms-mobile-list">

{filtered.map(r=>(
<div
key={r.id}
className="ms-item-card"
onClick={()=>handleRowDoubleClick(r)}
>

<div className="item-title">
{r.itemName}
</div>

<div className="item-row">
<span>Code : {r.code}</span>
<span>₹ {r.rate}</span>
</div>

<div className="item-row small">
HSN : {r.hsnCode} | Tax : {r.taxPercent}%
</div>

</div>
))}

</div>

) : (

filtered.map(r=>(
<div
key={r.id}
className={"ms-grid-row "+(r.id===selectedId ? "selected-row":"")}
onDoubleClick={()=>handleRowDoubleClick(r)}
>

<div className="ms-grid-cell">{r.code}</div>
<div className="ms-grid-cell">{r.itemName}</div>
<div className="ms-grid-cell">{r.unitValue}</div>
<div className="ms-grid-cell">{r.unitType}</div>
<div className="ms-grid-cell">{r.rate}</div>
<div className="ms-grid-cell">{r.hsnCode}</div>
<div className="ms-grid-cell">{r.taxPercent}</div>

</div>
))

)}

</div>

)}

{/* ENTRY SECTION */}

{(!isMobile || mobileTab === "entry") && (
<>
<div className={isMobile ? "ms-mobile-entry" : "ms-grid-adder"}>
<label>Item Name</label>
<input
ref={firstInputRef}
className="ms-grid-input adder"
placeholder="item name"
value={adder.itemName}
onChange={(e)=>{
const v = e.target.value.toUpperCase();
setAdder({...adder,itemName:v});
validateDuplicate(v,adder.hsnCode);
}}
/>
<label>Unit Value</label>
<input
className="ms-grid-input adder"
placeholder="unit value"
value={adder.unitValue}
onChange={(e)=>setAdder({...adder,unitValue:e.target.value})}
/>
<label>Unit Type</label>
<input
className="ms-grid-input adder"
placeholder="Unit"
value={adder.unitType}
readOnly
onClick={()=>setShowUnitPopup(true)}
/>
<label>Rate</label>
<input
className="ms-grid-input adder"
placeholder="rate"
value={adder.rate}
onChange={(e)=>setAdder({...adder,rate:e.target.value})}
/>
<label>HSN Code</label>
<input
className="ms-grid-input adder"
placeholder="hsn code"
value={adder.hsnCode}
onChange={(e)=>{
const v = e.target.value.toUpperCase();
setAdder({...adder,hsnCode:v});
validateDuplicate(adder.itemName,v);
}}
/>
<label>% of Tax</label>
<input
className="ms-grid-input adder"
placeholder="% of tax"
value={adder.taxPercent}
onChange={(e)=>setAdder({...adder,taxPercent:e.target.value})}
/>

</div>

<div className="ms-grid-actions">

<button
className="ms-btn ms-btn-primary"
onClick={saveItem}
>
{selectedId ? "UPDATE":"SAVE"}
</button>

<button
className="ms-btn"
onClick={resetForm}
>
NEW
</button>

</div>

</>

)}

</div>

</div>

</div>

{/* UNIT POPUP */}

{showUnitPopup && (

<div className="popup-overlay">

<div className="popup-box">

<div className="popup-header">

<span>Select Unit</span>

<button onClick={()=>setShowUnitPopup(false)}>✕</button>

</div>

<input
className="popup-search"
placeholder="Search unit"
value={unitSearch}
onChange={(e)=>setUnitSearch(e.target.value)}
/>

<div className="popup-list">

{filteredUnits.map((u,i)=>(
<div
key={i}
className="popup-row"
onClick={()=>{

setAdder({...adder,unitType:u});
setShowUnitPopup(false);

}}
>
{u}
</div>
))}

</div>

</div>

</div>

)}

{/* MOBILE BUTTON */}

{isMobile && (

<button
className="ms-add-btn"
onClick={()=>{

resetForm();
setMobileTab("entry");

}}
>
+
</button>

)}

{/* MOBILE NAV */}

{isMobile && (

<div className="ms-mobile-nav">

<button
className={mobileTab==="list" ? "active":""}
onClick={()=>setMobileTab("list")}
>
List
</button>

<button
className={mobileTab==="entry" ? "active":""}
onClick={()=>setMobileTab("entry")}
>
Entry
</button>

</div>

)}

</div>

);

}